import React, { useEffect, useRef, useCallback } from 'react';
import useState from 'react-usestateref'
import Amplify, { API, Auth } from 'aws-amplify';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';
import VideoWebcamRecorder from '../Practice/Recorder';
import { DragDropContainer, DropTarget } from 'react-drag-drop-container';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import tryAgainSound from '../../Unit1/Module1/assets/try_again.mp3';
import transitionSound  from './glisten.mp3';
import loading from './../../loading-gif-png-5.gif';
import { sleep } from '../../utils';


/**
 *  Creates and runs the practice section for Unit3 Module2
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const PracticeSituation = (props) => {
  // Initialize variables to be used later
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [day7Background, setDay7Background] = useState(props.background)
  const [practice, setPractice] = useState(false);
  const [question, setQuestion] = useState(false);
  const [recording, setRecording] = useState(false);
  const [takingVideo, setTakingVideo] = useState(false);
  const [introSound, setIntroSound] = useState('');
  const [animalVoice, setAnimalVoice] = useState('');
  const [optionVoice, setOptionVoice] = useState('');
  const [animalTalk, setAnimaTalk] = useState(false);
  const [numVideo, setNumVideo] = useState(0);

  const [numConversation1, setNumConversation1] = useState(0);
  
  const [instruction, setInstruction] = useState('');
  const [voice, setVoice] = useState('');
  const [displayAudio, setDisplayAudio] = useState(false);
  const [audioReady, setAudioReady] = useState(false);
  const [started, setStarted] = useState(true);
  const [displayAnimal, setDisplayAnimal] = useState(false);
  const [animateAnimal, setAnimateAnimal] = useState('');
  const [influencerVideo, setInfluencerVideo] = useState('');
  const [playVideo, setPlayVideo] = useState('');
  const [displayInfluencer, setDisplayInfluencer] = useState(false);
  const [conversation1, setConversation1] = useState(false);
  const [conversation2, setConversation2] = useState(false);
  const [example, setExample] = useState(false);

  const [correctImgX1, setCorrectImgX1] = useState('');
  const [correctImgX2, setCorrectImgX2] = useState('');
  const [correctImgX3, setCorrectImgX3] = useState('');
  const [correctImgY1, setCorrectImgY1] = useState('');
  const [correctImgY2, setCorrectImgY2] = useState('');
  const [correctImgY3, setCorrectImgY3] = useState('');
  const [wrongImgX1, setWrongImgX1] = useState('');
  const [wrongImgX2, setWrongImgX2] = useState('');
  const [wrongImgX3, setWrongImgX3] = useState('');
  const [wrongImgY1, setWrongImgY1] = useState('');
  const [wrongImgY2, setWrongImgY2] = useState('');
  const [wrongImgY3, setWrongImgY3] = useState('');
  const [correctImg1, setCorrectImg1] = useState('');
  const [correctImg2, setCorrectImg2] = useState('');
  const [correctImg3, setCorrectImg3] = useState('');
  const [wrongImg1, setWrongImg1] = useState('');
  const [wrongImg2, setWrongImg2] = useState('');
  const [wrongImg3, setWrongImg3] = useState('');
  const [correctImg1Zoom, setCorrectImg1Zoom] = useState('');
  const [correctImg2Zoom, setCorrectImg2Zoom] = useState('');
  const [correctImg3Zoom, setCorrectImg3Zoom] = useState('');
  const [wrongImg1Zoom, setWrongImg1Zoom] = useState('');
  const [wrongImg2Zoom, setWrongImg2Zoom] = useState('');
  const [wrongImg3Zoom, setWrongImg3Zoom] = useState('');

  const [seletedImg1, setSeletedImg1] = useState('');
  const [seletedImg2, setSeletedImg2] = useState('');
  const [seletedImg3, setSeletedImg3] = useState('');
  const [seletedImgX1, setSeletedImgX1] = useState('');
  const [seletedImgX2, setSeletedImgX2] = useState('');
  const [seletedImgX3, setSeletedImgX3] = useState('');
  const [seletedImgY1, setSeletedImgY1] = useState('');
  const [seletedImgY2, setSeletedImgY2] = useState('');
  const [seletedImgY3, setSeletedImgY3] = useState('');


  const [title, setTtitle] = useState('');
  const [changeText, setChangeText] = useState('');
  const [practice1, setPractice1] = useState(false);
  const [practice2, setPractice2] = useState(false);
  const [practice3, setPractice3] = useState(false);
  const [animationEffect, setAnimationEffect] = useState('animationEffect');
  const [animationEffectAfter, setAnimationEffectAfter] = useState('animationEffect');
  const [selectedCorrectImage, setSelectedCorrectImage] = useState(0);
  const [matchOptions, setMatchOptions] = useState(null);
  const [targetKey1, setTargetKey1] = useState('');
  const [targetKey2, setTargetKey2] = useState('');
  const [targetKey3, setTargetKey3] = useState('');
  const [doorStatus, setDoorStatus] = useState('closedDoor');
  const [score, setScore] = useState(0);
  const [firstTime, setFirstTime] = useState(true);
  const [item1, setItem1] = useState(true);
  const [firstTime1, setFirstTime1] = useState(true);
  const [item2, setItem2] = useState(true);
  const [firstTime2, setFirstTime2] = useState(true);
  const [item3, setItem3] = useState(true);
  const [firstTime3, setFirstTime3] = useState(true);
  const [wrongDrag, setWrongDrag, wrongDragRef] = useState(true);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
  const animalAudioRef = useRef(null);
  const expectedAnimalSrcRef = useRef('');
  const videoPlayer1 = {
    width: '370px',
    height: '655px',
    zIndex: 20,
  };

  const Exit = generateImageUrl('images/Images/close.png');
  const [door, setDoor] = useState(generateImageUrl('images/Module20Images/practice/U4M5_Practice_door.svg'));

  // CSS Code for the back button


  const videoPlayer = {
    minWidth: '100%',
    minHeight: '100%',
    position: 'relative',
  };

  useEffect(() => {
    setupGame1()
  }, []);

  const updateScore = async (score1) => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: "practice_caring",
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score1, target: 3 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleCorrectImage = async () => {
    if (selectedCorrectImage === 3){
      if (firstTime) setScore(score+1);
      setIntroSound('');
      setQuestion(false);
      setTtitle('Step 2: Fix it')
      setChangeText('Drag the item to fix the problem')
      setSeletedImgX1(props.gameInfo2.position[0].x)
      setSeletedImgY1(props.gameInfo2.position[0].y)
      setTargetKey1(props.gameInfo2.options[0].title)
      setSeletedImgX2(props.gameInfo2.position[1].x)
      setSeletedImgY2(props.gameInfo2.position[1].y)
      setTargetKey2(props.gameInfo2.options[1].title)
      setSeletedImgX3(props.gameInfo2.position[2].x)
      setSeletedImgY3(props.gameInfo2.position[2].y)
      setTargetKey3(props.gameInfo2.options[2].title)
      // if (!props.day5 && !props.day4 && !props.day8) {
      //   setWrongImg1(null)
      // }
      // if (!props.day5) {
      //   setWrongImg2(null)
      // }
      // if (!props.day6 && !props.day8) {
      //   setWrongImg3(null)
      // }
      if (props.day4){
        setWrongImg1(null)
        setWrongImg2(null)
        setWrongImg3(null)
      }
      setSeletedImg1(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      setSeletedImg2(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      setSeletedImg3(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      let numArray = [];
      numArray = [
        props.gameInfo2.options[0],
        props.gameInfo2.options[1],
        props.gameInfo2.options[2],
      ];
      numArray = numArray
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
      setMatchOptions(numArray);
      setAnimationEffect('');
      setIntroSound(getVideo('appfiles/caring/practice_game_days_step_2_fix_it.mp3', login));
      setQuestion(true);
      setPractice2(true)

    }
    else if (selectedCorrectImage === 6){
      if (item1 && item2 && item3) setScore(score+1);
      setFirstTime1(true);
      setFirstTime2(true);
      setFirstTime3(true);
      setItem1(true);
      setItem2(true);
      setItem3(true);
      setIntroSound('');
      setQuestion(false);
      setPractice2(false)
      setTtitle('Step 3: Make it even better')
      setChangeText('Drag the item to make it even better!')
      setSeletedImgX1(props.gameInfo3.position[0].x)
      setSeletedImgY1(props.gameInfo3.position[0].y)
      setTargetKey1(props.gameInfo3.options[0].title)
      setSeletedImgX2(props.gameInfo3.position[1].x)
      setSeletedImgY2(props.gameInfo3.position[1].y)
      setTargetKey2(props.gameInfo3.options[1].title)
      setSeletedImgX3(props.gameInfo3.position[2].x)
      setSeletedImgY3(props.gameInfo3.position[2].y)
      setTargetKey3(props.gameInfo3.options[2].title)
      setSeletedImg1(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      setSeletedImg2(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      setSeletedImg3(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      let numArray = [];
      numArray = [
        props.gameInfo3.options[0],
        props.gameInfo3.options[1],
        props.gameInfo3.options[2],
      ];
      numArray = numArray
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
      setMatchOptions(numArray);
      setAnimationEffect('');
      setIntroSound(getVideo('appfiles/caring/practice_game_days_step_3_make_it_better.mp3', login));
      setQuestion(true);
      setPractice3(true)
    }
    else if (selectedCorrectImage === 9) {

      if (numVideo < props.names.length) {
        setInstruction(getVideo(props.instructions[numVideo], login));
        setVoice(getVideo(props.voices[numVideo], login));
        setRecording(true);
        if (numVideo !== 0) {
          await sleep(1000);
          setTakingVideo(true);
        } else {
          if (item1 && item2 && item3) updateScore(score+1);
          else updateScore(score);
          (async () => {
            await new Promise((resolve) => setTimeout(resolve, 2 * 1000));
            setAnimalVoice(getVideo(props.introductionMP3, login));
            setAnimateAnimal(props.introduction);
            setDisplayAnimal(true);
            setPractice1(false);
          })();
        }
      } else {
        setAnimalVoice(getVideo('appfiles/close/close_practice_special_message.mp3', login));
        setInfluencerVideo(await GetUserVideo(`influencers/${props.influencerid}/conversation_affirmation.mp4`, login));
        setAnimateAnimal(props.practiceMessage);
        setDisplayAnimal(true);
        setPractice(true)
      }
    }
  }

  useEffect(() => {
    handleCorrectImage();
  }, [selectedCorrectImage, numVideo]);

  useEffect(() => {
    if (practice) {
      displayConversation();
    }
  }, [numConversation1]);

  // Sets up the game by selecting which possible answers to display in what order based on the current feeling.
  async function setupGame1() {
    setTtitle('Step 1: See it')
    setChangeText('Touch the 3 problems that need to be fixed')
    setCorrectImgX1(props.gameInfo1.position[0].x);
    setCorrectImgY1(props.gameInfo1.position[0].y);
    setCorrectImgX2(props.gameInfo1.position[1].x);
    setCorrectImgY2(props.gameInfo1.position[1].y);
    setCorrectImgX3(props.gameInfo1.position[2].x);
    setCorrectImgY3(props.gameInfo1.position[2].y);
    setWrongImgX1(props.gameInfo1.position[3].x);
    setWrongImgY1(props.gameInfo1.position[3].y);
    setWrongImgX2(props.gameInfo1.position[4].x);
    setWrongImgY2(props.gameInfo1.position[4].y);
    setWrongImgX3(props.gameInfo1.position[5].x);
    setWrongImgY3(props.gameInfo1.position[5].y);
    setCorrectImg1(props.gameInfo1.correctOptions[0])
    setCorrectImg2(props.gameInfo1.correctOptions[1])
    setCorrectImg3(props.gameInfo1.correctOptions[2])
    setWrongImg1(props.gameInfo1.incorrectOptions[0])
    setWrongImg2(props.gameInfo1.incorrectOptions[1])
    setWrongImg3(props.gameInfo1.incorrectOptions[2])
    setCorrectImg1Zoom(props.gameInfo1.position[0].zoom)
    setCorrectImg2Zoom(props.gameInfo1.position[1].zoom)
    setCorrectImg3Zoom(props.gameInfo1.position[2].zoom)
    setWrongImg1Zoom(props.gameInfo1.position[3].zoom)
    setWrongImg2Zoom(props.gameInfo1.position[4].zoom)
    setWrongImg3Zoom(props.gameInfo1.position[5].zoom)
    setIntroSound(getVideo('appfiles/caring/practice_game_days_step_1_see_it.mp3', login));
    setQuestion(true);
    setPractice1(true)
  }

  // Finds out what the user selected, and uses that as the current answer.
  async function onDrag(option) {
    if(targetKey1 === option.title){
      setItem1(false);
    }
    else if (targetKey2 === option.title){
      setItem2(false);
    }
    else if (targetKey3 === option.title){
      setItem3(false);
    }
    setOptionVoice('');
    setAnimaTalk(false);
    setWrongDrag(true)
    setQuestion(false);
    setOptionVoice(getVideo(option.audioPrompt, login));
    setAnimaTalk(true);
  }

  async function onDrop(order) {
    if(order === targetKey1){
      setFirstTime1(false)
    }
    else if (order === targetKey2){
      setFirstTime2(false)
    }
    else if (order === targetKey3){
      setFirstTime3(false)
    }
    if (wrongDragRef.current){
      const tryAgainAudio = new Audio(tryAgainSound)
      tryAgainAudio.play()
    }
  }

  const onHit1 = async (e) => {
    if (firstTime1) setItem1(true);
    const audio = new Audio(
      transitionSound
    );
    setWrongDrag(false)
    audio.play();
    setSeletedImg1(null);
    e.containerElem.style.visibility = 'hidden';
    if(practice2){
      setCorrectImg1(props.gameInfo2.answer1ImagesEnd)
      setCorrectImgX1(props.gameInfo2.afterPosition[0].x);
      setCorrectImgY1(props.gameInfo2.afterPosition[0].y);
      if(props.day7){
        setWrongImg1(null)
        setDay7Background(generateImageUrl('images/newDesign/Unit4Module20/Bakery/background/U4M5BakeryBGOpen.png'))
      }
      else if(props.day8){
        setWrongImg2(props.gameInfo1.correctOptions[0])
        setWrongImgX2('40%')
        setWrongImgY2('65%')
        setWrongImg3(null)
      }
    }
    else if(practice3){
      setCorrectImg1(props.gameInfo3.answer1ImagesEnd);
      setCorrectImgX1(props.gameInfo3.afterPosition[0].x);
      setCorrectImgY1(props.gameInfo3.afterPosition[0].y);
      if(props.day4){
        setWrongImg1(props.gameInfo3.answer4ImagesEnd)
        setWrongImgX1('75%')
        setWrongImgY1('47%')
      }
      else if(props.day5){
        setWrongImg1(props.gameInfo3.answer4ImagesEnd)
        if(window.innerWidth < 800){
          setWrongImgX1('5%')
          setWrongImgY1('')
        }
        else{
          setWrongImgX1('10%')
          setWrongImgY1('')
        }
      }
      else if(props.day8){
        setWrongImg2(props.gameInfo3.answer4ImagesEnd)
      }
    }
    setSelectedCorrectImage(selectedCorrectImage+1)
  };

  const onHit2 = async (e) => {
    if (firstTime2) setItem2(true);
    const audio = new Audio(
      transitionSound
    );
    setWrongDrag(false)
    audio.play();
    setSeletedImg2(null);
    e.containerElem.style.visibility = 'hidden';
    if(practice2){
      setCorrectImg2(props.gameInfo2.answer2ImagesEnd)
      setCorrectImgX2(props.gameInfo2.afterPosition[1].x);
      setCorrectImgY2(props.gameInfo2.afterPosition[1].y);
    }
    else if(practice3){
      if(props.day5){
        document.getElementById('hairMonkey').style.display='none'
      }
      setCorrectImg2(props.gameInfo3.answer2ImagesEnd)
      setCorrectImgX2(props.gameInfo3.afterPosition[1].x);
      setCorrectImgY2(props.gameInfo3.afterPosition[1].y);
      setCorrectImg2Zoom(props.gameInfo3.afterPosition[1].zoom)
    }
    setSelectedCorrectImage(selectedCorrectImage+1)
  };

  const onHit3 = async (e) => {
    if (firstTime3) setItem3(true);
    const audio = new Audio(
      transitionSound
    );
    setWrongDrag(false)
    audio.play();
    setSeletedImg3(null);
    e.containerElem.style.visibility = 'hidden';
    if(practice2){
      setCorrectImg3(props.gameInfo2.answer3ImagesEnd)
      setCorrectImgX3(props.gameInfo2.afterPosition[2].x);
      setCorrectImgY3(props.gameInfo2.afterPosition[2].y);
    }
    else if(practice3){
      setCorrectImg3(props.gameInfo3.answer3ImagesEnd)
      setCorrectImgX3(props.gameInfo3.afterPosition[2].x);
      setCorrectImgY3(props.gameInfo3.afterPosition[2].y);
    }
    setSelectedCorrectImage(selectedCorrectImage+1)
  };

  async function displayConversation() {
    if (numConversation1 <= props.names.length - 1) {
      setInstruction(getVideo(props.instructions[numConversation1], login));
      await GetUserVideo(`userfiles/${props.module.StudentID}/${props.names[numConversation1]}`).then((data) => {
        setPlayVideo(data);
        setConversation1(true);
      });
    } else {
      setInstruction(getVideo(props.instructions[numConversation1], login));
      setConversation1(true);
    }
  }

  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  useEffect(() => {
    let timer;
    if(displayAudio && isIOS()) {
      timer = setTimeout(() => {
        setAudioReady(false);
        setDisplayAudio(false);
        setDisplayAnimal(false);
        if (animateAnimal === props.introduction) {
          setExample(true);
        } else if (animateAnimal === props.practiceMessage) {
          setDisplayInfluencer(true);
        } else if (animateAnimal === props.practiceConversation) {
          displayConversation();
        } else if (animateAnimal === props.awesomeJob) {
          if (props.module.reviewIcon === false) {
            dispatch({ type: props.stepComplete, payload: 'practice' });
          }
          props.setDisplayPractice(false);
        }
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [displayAudio]);


  // The HTML code for the practice
  return (
    <>
      {displayAudio && <audio
        autoPlay
        src={animalVoice}
        playsInline
        onPlay={() => {
          setAudioReady(true);
        }}
        onEnded={() => {
          setAudioReady(false);
          setDisplayAudio(false);
          setDisplayAnimal(false);
          if (animateAnimal === props.introduction) {
            setExample(true);
          } else if (animateAnimal === props.practiceMessage) {
            setDisplayInfluencer(true);
          } else if (animateAnimal === props.practiceConversation) {
            displayConversation();
          } else if (animateAnimal === props.awesomeJob) {
            if (props.module.reviewIcon === false) {
              dispatch({ type: props.stepComplete, payload: 'practice' });
            }
            props.setDisplayPractice(false);
          }
        }}
      />}
      {practice1 && (
        <div
          className='practiceSituation'
          style={{ backgroundImage: `url(${props.background})` }}
        >
          {props.day7 && <img
            className='module20BG'
            src={day7Background}
          ></img>}
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br/>
          <h2 className='practiceSituationHeader'>{title}</h2>
          <h3 className='practiceSituationQuestion'>{changeText}</h3>
          {(props.day5) && <img alt='' id='hairMonkey' src={generateImageUrl('images/Module20Images/practice/Hairstylist_Monkey.svg')}  />}
          {/* {(props.day7) && 
            <div className='doorFrame'>
              <img alt='' className='frame' src={generateImageUrl('images/newDesign/Unit4Module20/Bakery/assets/Unit4Module20BakeryDoor.png')}  />
              <img alt='' className={doorStatus} src={door}  />
            </div>
          } */}
          <div
            className='gameElement'
            id={animationEffectAfter}
            style={{ top: correctImgY1, left: correctImgX1, zIndex:2, zoom: correctImg1Zoom }}
            onClick={() => {
              const audio = new Audio(
                generateImageUrl('media/Module1Videos/button_accept_item.mp3')
              );
              audio.play();
              document.getElementsByClassName(
                'gameElement'
              )[0].style.animation  = 'highlights 1s infinite alternate';
              document.getElementsByClassName(
                'gameElement'
              )[0].style.pointerEvents = 'none';
              setSelectedCorrectImage(selectedCorrectImage+1)
            }}
          >
            <div className='imgElement'>
              <img alt='' src={correctImg1} />
            </div>
          </div>
          <div
            className='gameElement'
            id={animationEffectAfter}
            style={{ top: correctImgY2, left: correctImgX2, zIndex:2, zoom: correctImg2Zoom }}
            onClick={() => {
              const audio = new Audio(
                generateImageUrl('media/Module1Videos/button_accept_item.mp3')
              );
              audio.play();
              document.getElementsByClassName(
                'gameElement'
              )[1].style.animation  = 'highlights 1s infinite alternate';
              document.getElementsByClassName(
                'gameElement'
              )[1].style.pointerEvents = 'none';
              setSelectedCorrectImage(selectedCorrectImage+1)
            }}
          >
            <div className='imgElement'>
              <img alt='' src={correctImg2} />
            </div>
          </div>
          {(props.day5) && 
            <div className='salonShelf'>
              <div className='waterSink'>
                <img
                  className='sink'
                  src={generateImageUrl("images/newDesign/Unit4Module20/Salon/assets/Unit4Module20SalonSink.png")}
                  alt='sink'
                />
                <div
                  className='gameElement'
                  id={animationEffectAfter}
                  style={{ top: correctImgY3, left: correctImgX3, zIndex:2, zoom: correctImg3Zoom }}
                  onClick={() => {
                    const audio = new Audio(
                      generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                    );
                    audio.play();
                    document.getElementsByClassName(
                      'gameElement'
                    )[2].style.animation  = 'highlights 1s infinite alternate';
                    document.getElementsByClassName(
                      'gameElement'
                    )[2].style.pointerEvents = 'none';
                    setSelectedCorrectImage(selectedCorrectImage+1)
                  }}
                >
                  <div className='imgElement'>
                    <img alt='' src={correctImg3} />
                  </div>
                </div>
                {seletedImg3 &&(
                  <div
                    className='seletedImage'
                    style={{ top: seletedImgY3, left: seletedImgX3 }}
                  >
                    <DropTarget
                      targetKey={targetKey3}
                      onHit={(e) => {
                        onHit3(e);
                      }}
                      style={{ height: '150px', width: '150px' }}
                    >
                      <img alt='' className='selectedBox' src={seletedImg3} />
                    </DropTarget>
                  </div>
                )}
              </div>
              <img
                className='shelf'
                src={generateImageUrl("images/newDesign/Unit4Module20/Salon/assets/shelf.png")}
                alt='shelf'
              />
              <div
                className='gameElement'
                id={animationEffect}
                style={{ bottom: wrongImgY1, left: wrongImgX1, zoom: wrongImg1Zoom }}
                onClick={() => {
                  setAnimalVoice('');
                  setAnimaTalk(false);
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[3].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[3].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg1} />
                </div>
              </div>
              <div
                className='gameElement'
                id={animationEffect}
                style={{ bottom: wrongImgY2, left: wrongImgX2, zoom: wrongImg2Zoom }}
                onClick={() => {
                  setAnimalVoice('');
                  setAnimaTalk(false);
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg2} />
                </div>
              </div>
              <div
                className='gameElement'
                id={animationEffect}
                style={{ bottom: wrongImgY3, left: wrongImgX3, zoom: wrongImg3Zoom }}
                onClick={() => {
                  setAnimalVoice('');
                  setAnimaTalk(false);
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[5].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[5].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg3} />
                </div>
              </div>
            </div>
          }
          {(props.day6) && 
            <div className='clothingShelf'>
              <img
                className='shelf'
                src={generateImageUrl("images/newDesign/Unit4Module20/Clothing/assets/Unit4Module20ClothingShelf.png")}
                alt='shelf'
              />
              <div
                className='gameElement'
                id={animationEffectAfter}
                style={{ top: correctImgY3, left: correctImgX3, zIndex:2, zoom: correctImg3Zoom }}
                onClick={() => {
                  const audio = new Audio(
                    generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                  );
                  audio.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[2].style.animation  = 'highlights 1s infinite alternate';
                  document.getElementsByClassName(
                    'gameElement'
                  )[2].style.pointerEvents = 'none';
                  setSelectedCorrectImage(selectedCorrectImage+1)
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={correctImg3} />
                </div>
              </div>
              <div
                className='gameElement'
                id={animationEffect}
                style={{ top: wrongImgY1, left: wrongImgX1, zoom: wrongImg1Zoom }}
                onClick={() => {
                  setAnimalVoice('');
                  setAnimaTalk(false);
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[3].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[3].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg1} />
                </div>
              </div>
              <div
                className='gameElement'
                id={animationEffect}
                style={{ top: wrongImgY2, left: wrongImgX2, zoom: wrongImg2Zoom }}
                onClick={() => {
                  setAnimalVoice('');
                  setAnimaTalk(false);
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg2} />
                </div>
              </div>
              {seletedImg3 &&(
                <div
                  className='seletedImage'
                  style={{ top: seletedImgY3, left: seletedImgX3 }}
                >
                  <DropTarget
                    targetKey={targetKey3}
                    onHit={(e) => {
                      onHit3(e);
                    }}
                    style={{ height: '150px', width: '150px' }}
                  >
                    <img alt='' className='selectedBox' src={seletedImg3} />
                  </DropTarget>
                </div>
              )}
            </div>
          }
          {!props.day6 && !props.day5 && <div
            className='gameElement'
            id={animationEffectAfter}
            style={{ top: correctImgY3, left: correctImgX3, zIndex:2, zoom: correctImg3Zoom }}
            onClick={() => {
              const audio = new Audio(
                generateImageUrl('media/Module1Videos/button_accept_item.mp3')
              );
              audio.play();
              document.getElementsByClassName(
                'gameElement'
              )[2].style.animation  = 'highlights 1s infinite alternate';
              document.getElementsByClassName(
                'gameElement'
              )[2].style.pointerEvents = 'none';
              setSelectedCorrectImage(selectedCorrectImage+1)
            }}
          >
            <div className='imgElement'>
              <img alt='' src={correctImg3} />
            </div>
          </div>}
          {(!props.day6) && !props.day5 && <div
            className='gameElement'
            id={animationEffect}
            style={props.day8 ? { bottom: wrongImgY1, left: wrongImgX1, zoom: wrongImg1Zoom } : { top: wrongImgY1, left: wrongImgX1, zoom: wrongImg1Zoom }}
            onClick={() => {
              setAnimalVoice('');
              setAnimaTalk(false);
              let tryAgain = new Audio(tryAgainSound)
              tryAgain.play();
              document.getElementsByClassName(
                'gameElement'
              )[3].style.pointerEvents = 'none';
              document.getElementsByClassName(
                'gameElement'
              )[3].style.animationDuration = '0s';
              setFirstTime(false);
            }}
          >
            <div className='imgElement'>
              <img alt='' src={wrongImg1} />
            </div>
          </div>}
          {(props.day7) && 
            <div className='breadShelf'>
              <img
                className='shelf'
                src={generateImageUrl("images/newDesign/Unit4Module20/Bakery/assets/Unit4Module20BakeryShelf.png")}
                alt='shelf'
              />
              <div
                className='gameElement'
                id={animationEffect}
                style={{ top: wrongImgY2, left: wrongImgX2, zoom: wrongImg2Zoom }}
                onClick={() => {
                  setAnimalVoice('');
                  setAnimaTalk(false);
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg2} />
                </div>
              </div>
              <div
                className='gameElement'
                id={animationEffect}
                style={{ top: wrongImgY3, left: wrongImgX3, zoom: wrongImg3Zoom }}
                onClick={() => {
                  setAnimalVoice('');
                  setAnimaTalk(false);
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[5].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[5].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg3} />
                </div>
              </div>
            </div>
          }
          {!props.day6 && !props.day7 && !props.day5 && <div
            className='gameElement'
            id={animationEffect}
            style={{ top: wrongImgY2, left: wrongImgX2, zoom: wrongImg2Zoom }}
            onClick={() => {
              setAnimalVoice('');
              setAnimaTalk(false);
              let tryAgain = new Audio(tryAgainSound)
              tryAgain.play();
              document.getElementsByClassName(
                'gameElement'
              )[4].style.pointerEvents = 'none';
              document.getElementsByClassName(
                'gameElement'
              )[4].style.animationDuration = '0s';
              setFirstTime(false);
            }}
          >
            <div className='imgElement'>
              <img alt='' src={wrongImg2} />
            </div>
          </div>}
          {!props.day7 && !props.day5 && <div
            className='gameElement'
            id={animationEffect}
            style={{ top: wrongImgY3, left: wrongImgX3, zoom: wrongImg3Zoom }}
            onClick={() => {
              setAnimalVoice('');
              setAnimaTalk(false);
              let tryAgain = new Audio(tryAgainSound)
              tryAgain.play();
              document.getElementsByClassName(
                'gameElement'
              )[5].style.pointerEvents = 'none';
              document.getElementsByClassName(
                'gameElement'
              )[5].style.animationDuration = '0s';
              setFirstTime(false);
            }}
          >
            <div className='imgElement'>
              <img alt='' src={wrongImg3} />
            </div>
          </div>}
          {seletedImg1 && (
            <div
              className='seletedImage'
              style={{ top: seletedImgY1, left: seletedImgX1 }}
            >
              <DropTarget
                targetKey={targetKey1}
                onHit={(e) => {
                  onHit1(e);
                }}
                
                style={{ height: '150px', width: '150px' }}
              >
                <img alt='' className='selectedBox' src={seletedImg1} />
              </DropTarget>
            </div>
            
          )}
          {seletedImg2 && (
            <div
              className='seletedImage'
              style={{ top: seletedImgY2, left: seletedImgX2 }}
            >
              <DropTarget
                targetKey={targetKey2}
                onHit={(e) => {
                  onHit2(e);
                }}
                style={{ height: '150px', width: '150px' }}
              >
                <img alt='' className='selectedBox' src={seletedImg2} />
              </DropTarget>
            </div>
            
          )}
          {seletedImg3 && !props.day6  && !props.day5 &&(
            <div
              className='seletedImage'
              style={{ top: seletedImgY3, left: seletedImgX3 }}
            >
              <DropTarget
                targetKey={targetKey3}
                onHit={(e) => {
                  onHit3(e);
                }}
                style={{ height: '150px', width: '150px' }}
              >
                <img alt='' className='selectedBox' src={seletedImg3} />
              </DropTarget>
            </div>
          )}
          {practice2 && (
            <div className='practice20GridDay4'>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[0], id: 0 }}
                  targetKey={matchOptions[0].title}
                  onDragStart={() => onDrag(matchOptions[0])}
                  onDragEnd={() => onDrop(matchOptions[0].title)}
                >
                  {matchOptions[0] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[0].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[1], id: 1 }}
                  targetKey={matchOptions[1].title}
                  onDragStart={() => onDrag(matchOptions[1])}
                  onDragEnd={() => onDrop(matchOptions[1].title)}
                >
                  {matchOptions[1] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[1].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[2], id: 2 }}
                  targetKey={matchOptions[2].title}
                  onDragStart={() => onDrag(matchOptions[2])}
                  onDragEnd={() => onDrop(matchOptions[2].title)}
                >
                  {matchOptions[2] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[2].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
            </div>
          )}
          {practice3 && (
            <div className='practice20GridDay4'>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[0], id: 0 }}
                  targetKey={matchOptions[0].title}
                  onDragStart={() => onDrag(matchOptions[0])}
                  onDragEnd={() => onDrop(matchOptions[0].title)}
                >
                  {matchOptions[0] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[0].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[1], id: 1 }}
                  targetKey={matchOptions[1].title}
                  onDragStart={() => onDrag(matchOptions[1])}
                  onDragEnd={() => onDrop(matchOptions[1].title)}
                >
                  {matchOptions[1] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[1].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[2], id: 2 }}
                  targetKey={matchOptions[2].title}
                  onDragStart={() => onDrag(matchOptions[2])}
                  onDragEnd={() => onDrop(matchOptions[2].title)}
                >
                  {matchOptions[2] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[2].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
            </div>
          )}          
        </div>
      )}

      {recording && (
        <div
          id='recordpage'
          style={{ backgroundImage: `url(${props.background1})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          {takingVideo && (
            <VideoWebcamRecorder
              background={props.background1}
              instruction={instruction}
              outputText={props.texts[numVideo]}
              name={props.names[numVideo]}
              voice={voice}
              close={props.setDisplayPractice}
              ended={() => {
                setNumVideo(numVideo + 1);
                setTakingVideo(false);
              }}
            />
          )}
          {displayAnimal && (
            <img
              className='bigAnimal'
              style={audioReady ? {} : { display: 'none' }}
              onLoad={() => setDisplayAudio(true)}
              src={animateAnimal}
            />
          )}
          {displayAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {displayInfluencer && (
            <div id='influencerVideo'>
              <video
                style={videoPlayer}
                autoPlay
                controls={isIOS() ? started : false}
                onPlaying={() => {
                  setStarted(false);
                }}
                onEnded={async () => {
                  setAnimalVoice(getVideo('appfiles/close/close_practice_watch_conversation.mp3', login));
                  setAnimateAnimal(props.practiceConversation);
                  setDisplayAnimal(true);
                  setDisplayInfluencer(false);
                }}
                onError={async () => {
                  setAnimalVoice(getVideo('appfiles/close/close_practice_watch_conversation.mp3', login));
                  setAnimateAnimal(props.practiceConversation);
                  setDisplayAnimal(true);
                  setDisplayInfluencer(false);
                }}
                playsInline
              >
                <source src={influencerVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
          {example && (
            <CloudfrontVideoFormat
              source={props.exampleVideo}
              back='/unit4'
              background={props.background1}
              close={props.setDisplayPractice}
              ended={() => {
                setExample(false);
                setTakingVideo(true);
              }}
          />)}
          {conversation1 && (
            <div id='borderVideo'>
              <video
                style={videoPlayer1}
                autoPlay
                controls={isIOS() ? started : false}
                onPlaying={() => {
                  setStarted(false);
                }}
                onEnded={async () => {
                  setConversation1(false);
                  if (numConversation1 > props.names.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo('appfiles/close/close_awesome_job.mp3', login));
                    setDisplayAnimal(true);
                  } else {
                    setConversation2(true);
                  }
                }}
                onError={async () => {
                  setConversation1(false);
                  if (numConversation1 > props.names.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo('appfiles/close/close_awesome_job.mp3', login));
                    setDisplayAnimal(true);
                  } else {
                    setConversation2(true);
                  }
                }}
                playsInline
              >
                <source src={instruction} type='video/mp4'></source>
              </video>
            </div>
          )}
          {conversation2 && (
            <div id='border'>
              <video
                style={{ width: '391px', height: '580px', left: '50%' }}
                autoPlay
                controls={isIOS() ? started : false}
                onPlaying={() => {
                  setStarted(false);
                }}
                onEnded={async () => {
                  setConversation2(false);
                  if (numConversation1 === props.instructions.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo('appfiles/close/close_awesome_job.mp3', login));
                    setDisplayAnimal(true);
                  } else {
                    setNumConversation1(numConversation1 + 1);
                  }
                }}
                onError={async () => {
                  setConversation2(false);
                  if (numConversation1 === props.instructions.length - 1) {
                    setAnimateAnimal(props.awesomeJob);
                    setAnimalVoice(getVideo('appfiles/close/close_awesome_job.mp3', login));
                    setDisplayAnimal(true);
                  } else {
                    setNumConversation1(numConversation1 + 1);
                  }
                }}
                playsInline
              >
                <source src={playVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
        </div>
      )}
      {!animalTalk && question && (
        <audio
          autoPlay
          onEnded={() => {
            setQuestion(false);
          }}
        >
          <source src={introSound}></source>
        </audio>
      )}
      {animalTalk && (
        <audio
          autoPlay
          onEnded={() => {
            setAnimaTalk(false);
          }}
        >
          <source src={optionVoice}></source>
        </audio>
      )}
    </>
  );
};
export default PracticeSituation;
